// app/javascript/packs/index.js

// Run this example by adding <%= javascript_pack_tag 'hello_react' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Hello React</div> at the bottom
// of the page.

import React from 'react';
import ReactDOM from 'react-dom';
import App from '../components/App';

document.addEventListener('DOMContentLoaded', () => {
  const mountNode = document.getElementById('data-node');
  const styleName = mountNode.getAttribute('data-style_name');
  const myContainer = document.createElement('div');
  myContainer.setAttribute('class', styleName);

  ReactDOM.render(
    <App />,
    document.body.appendChild(myContainer),
  );
});
